import {Typography} from '@mui/material'

interface StatusBadgeProps {
    status:
        | 'FINISHED'
        | 'PROCESSING'
        | 'GENERATING_DOCS'
        | 'INCOMPLETE'
        | 'PENDING'
        | 'FAILED'
}

const STATUS_CONFIG = {
    FINISHED: {text: 'Pronto', color: '#23CB69', maxWidth: '60px'},
    PROCESSING: {text: 'Processando', color: '#7B68EE', maxWidth: '90px'},
    GENERATING_DOCS: {text: 'Processando', color: '#7B68EE', maxWidth: '90px'},
    INCOMPLETE: {text: 'Incompleto', color: '#FFA500', maxWidth: '85px'},
    PENDING: {text: 'Pendente', color: '#FFA500', maxWidth: '85px'},
    FAILED: {text: 'Falhou', color: '#FF4D4D', maxWidth: '60px'},
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({status}) => {
    const config = STATUS_CONFIG[status] || STATUS_CONFIG.PENDING

    return (
        <Typography
            variant="body2"
            style={{
                maxWidth: config.maxWidth,
                color: 'white',
                backgroundColor: config.color,
                padding: '6px',
                borderRadius: '100px',
                textAlign: 'center',
            }}
        >
            {config.text}
        </Typography>
    )
}
